module.exports = __webpack_public_path__ + "img/浏览记录.46419dbe.svg";